import { IRBDItem } from '../../../../models/rbd'
import { RBDItemType, RBDTransmissionType } from '../../../../config/enum'
import finder, { SELECTOR } from './finder'



/**
 * validate the object is instance of IRBDItem
 * 
 * @param obj 
 * @returns boolean
 */
 export const isIRBDItem = (obj: any): obj is IRBDItem => {
    if (Array.isArray(obj)) {
        return (
            'sequence' in obj[0] 
            && 'name' in obj[0] 
            && 'itemType' in obj[0] 
            && 'element' in obj[0] 
            && 'transmission' in obj[0] 
            && 'isGrouped' in obj[0]
        )
    } else {
        return (
            'sequence' in obj
            && 'name' in obj
            && 'itemType' in obj
            && 'element' in obj
            && 'transmission' in obj
            && 'isGrouped' in obj
        )
    }
}



/**
 * Validate the value of an array is number only.
 * 
 * @param array - number[] 
 * @returns 
 */
export const isArrayOfNumber = (array: any): boolean => {
    if (Array.isArray(array)) {
        return array.every(n => typeof n === 'number')
    } else {
        return false
    }
}



/**
 * 
 * @param obj IRBDItem
 * @returns boolean
 */
export const isElement = (obj: IRBDItem): boolean => 
    finder(obj, SELECTOR.ITEM_TYPE) === RBDItemType.ELEMENT



/**
 * validate if the transmission type of an object is 'SERIAL'
 * 
 * @param obj - IRBDItem
 * @return boolean
 */
export const isSerialTransmission = (obj: IRBDItem): boolean => 
    finder(obj, SELECTOR.TRANSMISSION_TYPE) === RBDTransmissionType.SERIAL



/**
 * validate if the transmission type of an object is 'REDUNDANT'
 * 
 * @param obj - IRBDItem
 * @return boolean
 */
export const isRedundantTransmission = (obj: IRBDItem): boolean => 
    finder(obj, SELECTOR.TRANSMISSION_TYPE) === RBDTransmissionType.REDUNDANT



/**
 * validate if the transmission type of an object is 'PARALEL' or 'SHARING_LOAD'
 * 
 * @param obj - IRBDItem
 * @return boolean
 */
export const isParalelTransmission = (obj: IRBDItem): boolean => {
    switch (finder(obj, SELECTOR.TRANSMISSION_TYPE)) {
        case RBDTransmissionType.PARALLEL:
        case RBDTransmissionType.SHARING_LOAD:
            return true;
        default: 
            return false
    }
}



/**
 * will return true when equipmentType is 'PIPE'
 * 
 * @param obj IRBDItem
 * @returns 
 */
export const equipmentIsPipe = (obj: IRBDItem) => {
    if (finder(obj, 'element.equipmentType')) {
        return finder(obj, 'element.equipmentType').toLowerCase() === 'PIPE'.toLowerCase()
        || finder(obj, 'element.equipmentType').toLowerCase() === 'Piping'.toLowerCase()
    }
}



/**
 * will return true when equipmentType is 'PRESSURE_VESSEL'
 * 
 * @param obj IRBDItem
 * @returns
 */
export const equipmentIsPsv = (obj: IRBDItem) => {
    if (finder(obj, 'element.equipmentType')) {
        const equipmentType = process.env.REACT_APP_EQUIPMENT_TYPE
        const arrayOfEquipment = equipmentType?.split(' ') ?? []

        const res = arrayOfEquipment.map(i => finder(obj, 'element.equipmentType').toLowerCase().includes(i.toLowerCase()))
        return res.includes(true)
    } else {
        const systemName = process.env.REACT_APP_SYSTEM_NAME;
        const arrayOfSystem = systemName?.split(' ') ?? []

        const res = arrayOfSystem.map(i => finder(obj, 'element.name').toLowerCase().includes(i.toLowerCase()))
        return res.includes(true)
    }
}
